import { render } from "./MultipleChoice.vue?vue&type=template&id=bacd005c&scoped=true&lang=html"
import script from "./MultipleChoice.vue?vue&type=script&lang=js"
export * from "./MultipleChoice.vue?vue&type=script&lang=js"

import "./MultipleChoice.vue?vue&type=style&index=0&id=bacd005c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bacd005c"]])

export default __exports__